export class GetProviderTokenError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'GetProviderTokenError';
        this.stack = stack;
        Object.setPrototypeOf(this, GetProviderTokenError.prototype);
    }
}
